import React from 'react';
import { css } from '@emotion/css';
import dayjs from 'dayjs';
import { Customers } from '@gql/base-types';
import { useGetCustomersAndMovesLazyQuery } from '../queries/getCustomersAndMoves.query.generated';
import { useGetCustomersAndMovesForLiteLazyQuery } from '../queries/getCustomersAndMovesForLite.query.generated';
import { Paper } from '@mui/material';
import { useProductsLoaded } from '@store';
import { useValetSelfManaged } from '@hopdrive/feature-portal-products';
import OverviewHeader from '@features/rooftops/components/OrganizationOverviewTableHeader';
import OverviewBody from '@features/rooftops/components/OrganizationOverviewTableBody';
const log = false;

const OrganizationOverview: React.FC = () => {
  const cls = useStyles();

  const storedDate = localStorage.getItem('overview-date');
  const today = dayjs().toString();

  const [getCustomersAndMoves] = useGetCustomersAndMovesLazyQuery();
  const [getCustomersAndMovesForLite] = useGetCustomersAndMovesForLiteLazyQuery();
  const [date, setDate] = React.useState<string>(storedDate || today);
  const [customers, setCustomers] = React.useState<Customers[]>([]);

  // The query shape follows the working rooftop's operational model, so the fetch waits for the
  // products to settle; a response for a superseded model or date is dropped.
  const isLiteTier = useValetSelfManaged();
  const productsLoaded = useProductsLoaded();

  React.useEffect(() => {
    if (!productsLoaded) return;
    let stale = false;
    const fetchCustomersAndSetState = async () => {
      try {
        let dt = dayjs(date);
        //create start and end of day ISO strings so that the query will only select one day's worth of moves
        let startOfDate = dt.startOf('day').toString();
        let endOfDate = dt.endOf('day').toString();
        log && console.log('dates', date, startOfDate, endOfDate, 'isLiteTier', isLiteTier);
        
        // Use appropriate query based on rooftop tier
        const queryToUse = isLiteTier ? getCustomersAndMovesForLite : getCustomersAndMoves;
        const res = await queryToUse({ variables: { start: startOfDate, end: endOfDate } });
        
        const resCustomers = res?.data?.customers || [];
        const interableCustomers: Customers[] | undefined = resCustomers.map(customer => ({
          ...customer,
        })) as Customers[];
        if (interableCustomers.length === 0) {
          console.error('No customers found');
        }
        if (!stale) setCustomers(interableCustomers);
      } catch (err) {
        console.error(`Failed to fetch customers:`, err);
      }
    };
    fetchCustomersAndSetState();
    return () => {
      stale = true;
    };
  }, [date, isLiteTier, productsLoaded, getCustomersAndMoves, getCustomersAndMovesForLite]);

  return (
    customers?.length && (
      <Paper className={cls.root}>
        <OverviewHeader customers={customers} date={date} setDate={setDate} />
        <OverviewBody customers={customers} />
      </Paper>
    )
  );
};

export default OrganizationOverview;

const useStyles = () => ({
  root: css`
    width: fit-content;
  `,
});
